import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from '../../../../../../lib/designSystem/Button';
import { createNewRole } from '../../../../../../lib/api/users/roles';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../../../../../lib/functions/utils';

type Props = {
  open: boolean;
  onClose: () => void;
  onRoleCreated: (roleName: string) => Promise<void>;
};

const AddRoleDialog: React.FC<Props> = ({ open, onClose, onRoleCreated }) => {
  const dispatch = useDispatch();
  const [roleName, setRoleName] = useState('');
  const handleAddRole = async () => {
    try {
      await createNewRole(dispatch, { name: roleName });
      await onRoleCreated(roleName);
      showAlert(dispatch, 'success', 'Rol creado correctamente');
    } catch (error) {
      console.error(error);
    } finally {
      onClose();
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <Typography variant="h4" padding="10px 10px">
        Agregar Rol
      </Typography>
      <DialogContent>
        <TextField
          label="Nombre del Rol"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleAddRole} color="primary">
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddRoleDialog;
